import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as AdaptedStateActions from '@store/actions/adapted-state/adapted-state.actions';
import { AdaptedState, TransactionState } from '@store/index';

export const transactionsAdapter: EntityAdapter<TransactionState> =
  createEntityAdapter<TransactionState>({
    selectId: (state: TransactionState) => state.currentTransactionId,
  });

export const initialState: AdaptedState = transactionsAdapter.getInitialState({});

export const adaptedStateReducer = createReducer(
  initialState,
  on(AdaptedStateActions.AddStateToTransactions, (adaptedState, { state }) =>
    transactionsAdapter.addOne(state, adaptedState),
  ),
  on(AdaptedStateActions.UpdateTransactionState, (adaptedState, { update }) =>
    transactionsAdapter.updateOne(update, adaptedState),
  ),
  on(AdaptedStateActions.DeleteTransactionState, (state, { id }) =>
    transactionsAdapter.removeOne(id, state),
  ),
  on(AdaptedStateActions.LoadTransactionStates, (state, { states }) =>
    transactionsAdapter.setAll(states, state),
  ),
  on(AdaptedStateActions.ClearTransactionStates, (state) =>
    transactionsAdapter.removeAll({ ...state, currentTransactionId: null }),
  ),
);

export const transactionIdReducer = createReducer(
  '',
  on(AdaptedStateActions.SetTransactionId, (state, { id }) => id),
  on(AdaptedStateActions.ClearCurrentTransactionState, () => ''),
  on(
    AdaptedStateActions.SetTransactionAsCurrent,
    (state, { transaction }) => transaction.currentTransactionId,
  ),
);
